import React from 'react';
import { Link } from 'react-router-dom';
import PlatformLayout from '../PlatformLayout';
import { Arrow } from '../icons';

export default function Pricing() {
  return (
    <PlatformLayout>
      <section className="sgk-section sgk-section--tight">
        <div className="sgk-wrap">
          <div className="sgk-head sgk-reveal">
            <span className="sgk-eyebrow">Pricing</span>
            <h2>We win when <em>you</em> win.</h2>
            <p>No cut of your donations. A membership fee capped so it can never overrun
              your budget. Full transparency on every processing fee.</p>
          </div>
        </div>
      </section>

      <section className="sgk-section" style={{ paddingTop: 0 }}>
        <div className="sgk-wrap sgk-pricing">
          <div className="sgk-pricecard sgk-pricecard--lead sgk-reveal">
            <h3>Membership</h3>
            <div className="sgk-pricecard__cap">$500<span style={{ fontSize: '0.4em' }}>/mo</span></div>
            <div className="sgk-pricecard__sub">…or 5% of donations through the platform — whichever is lower.</div>
            <ul>
              <li>The full toolkit — every module included</li>
              <li>Unlimited donations and applications</li>
              <li>Your public site and footprint map</li>
              <li>Capped so it never overruns your 10% opex budget</li>
            </ul>
          </div>
          <div className="sgk-pricecard sgk-reveal">
            <h3>Processing</h3>
            <div className="sgk-pricecard__cap" style={{ color: 'var(--gold-700)' }}>0%</div>
            <div className="sgk-pricecard__sub" style={{ color: 'var(--ink-soft)' }}>
              of your donation is ours. Fees pass straight through.
            </div>
            <p style={{ marginTop: 16 }}>
              Donations run on Stripe at non-profit discount rates and settle directly
              into your account. We add nothing on top — the fee you see is the fee Stripe
              charges, in full view.
            </p>
            <ul>
              <li>Non-profit discount processing rates</li>
              <li>No platform markup, ever</li>
              <li>Funds settle straight to your account</li>
            </ul>
          </div>
        </div>

        <div className="sgk-wrap" style={{ marginTop: 40 }}>
          <div className="sgk-finepr sgk-reveal">
            <b>The fine print, in plain terms.</b> The $500/month cap is annualized. If you
            take $0 in donations in January and $20,000 in February, 5% of February would
            be $1,000 — so your February bill is $1,000, drawing on the room January left
            under the cap. The point is simple: in a strong month you pay a small slice; in
            a lean month you pay almost nothing; over a year you never pay more than the cap.
          </div>
        </div>

        <div className="sgk-wrap" style={{ marginTop: 28 }}>
          <p style={{ color: 'var(--ink-mute)', fontSize: 14.5 }}>
            Need custom work? We offer hands-on customization support as a consulting
            arrangement — <Link to="/signup" style={{ color: 'var(--gold-700)', fontWeight: 700 }}>get in touch</Link> once you&apos;re set up.
          </p>
        </div>
      </section>

      <section className="sgk-cta">
        <div className="sgk-wrap sgk-cta__grid">
          <div>
            <h2>Pricing that roots for you.</h2>
            <p>Create your organization and start taking donations — no card required to begin.</p>
          </div>
          <Link to="/signup" className="sgk-btn sgk-btn--navy" data-testid="pricing-cta-start-button">
            Start an SGO <Arrow />
          </Link>
        </div>
      </section>
    </PlatformLayout>
  );
}
